import styled from "styled-components";

const EmployeeHouseVisitsWrapper = styled.div`
  overflow: auto;
  .ant-table-body {
    // min-height: calc(100vh - 420px);
  }
`;

export default EmployeeHouseVisitsWrapper;
